import { render } from "./BtnDefault.vue?vue&type=template&id=acac5b6a"
import script from "./BtnDefault.vue?vue&type=script&lang=js"
export * from "./BtnDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__